export enum Status {
  Approved = 'approved',
  Rejected = 'rejected',
  Edited = 'edited',
  Pending = 'pending',
  Processing = 'processing',
  Disabled = 'disabled',
  Deleted = 'deleted',
  None = 'none',
  New = 'new',
}
